import React from 'react';

import InterpretationPage01 from '../axuminInterpretation/InterpretationPage01';
import InterpretationPage02 from '../axuminInterpretation/InterpretationPage02';
import InterpretationPage03 from '../axuminInterpretation/InterpretationPage03';
import InterpretationPage04 from '../axuminInterpretation/InterpretationPage04';
import InterpretationPage05 from '../axuminInterpretation/InterpretationPage05';
import InterpretationPage06 from '../axuminInterpretation/InterpretationPage06';
import InterpretationPage07 from '../axuminInterpretation/InterpretationPage07';
import InterpretationPage08 from '../axuminInterpretation/InterpretationPage08';
import InterpretationPage09 from '../axuminInterpretation/InterpretationPage09';
import InterpretationPage10 from '../axuminInterpretation/InterpretationPage10';
import InterpretationPage11 from '../axuminInterpretation/InterpretationPage11';
import InterpretationPage12 from '../axuminInterpretation/InterpretationPage12';
import InterpretationPage13 from '../axuminInterpretation/InterpretationPage13';
import InterpretationPage14 from '../axuminInterpretation/InterpretationPage14';
import InterpretationPage15 from '../axuminInterpretation/InterpretationPage15';
import InterpretationPage16 from '../axuminInterpretation/InterpretationPage16';
import InterpretationPage17 from '../axuminInterpretation/InterpretationPage17';
import InterpretationPage18 from '../axuminInterpretation/InterpretationPage18';
import InterpretationPage19 from '../axuminInterpretation/InterpretationPage19';
import AcquisitionPage01 from '../axuminAcquisition/AcquisitionPage01';
import AcquisitionPage02 from '../axuminAcquisition/AcquisitionPage02';
import AcquisitionPage03 from '../axuminAcquisition/AcquisitionPage03';
import AcquisitionPage04 from '../axuminAcquisition/AcquisitionPage04';
import AcquisitionPage05 from '../axuminAcquisition/AcquisitionPage05';
import AcquisitionPage06 from '../axuminAcquisition/AcquisitionPage06';
import AcquisitionPage07 from '../axuminAcquisition/AcquisitionPage07';
import AcquisitionPage08 from '../axuminAcquisition/AcquisitionPage08';
import AcquisitionPage09 from '../axuminAcquisition/AcquisitionPage09';
import AcquisitionPage10 from '../axuminAcquisition/AcquisitionPage10';
import AcquisitionPage11 from '../axuminAcquisition/AcquisitionPage11';

type MainPageProps = {
  module: string;
  page: number;
  setNextDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  setNextDisabledCS: React.Dispatch<React.SetStateAction<boolean>>;
};

const MainPageAxumin = ({ module, page, setNextDisabled, setNextDisabledCS }: MainPageProps): JSX.Element => {
  const renderMainPage = () => {
    if (module === 'axuminInterpretation') {
      switch (page) {
        case 1: {
          return <InterpretationPage01 />;
        }
        case 2: {
          return <InterpretationPage02 />;
        }
        case 3: {
          return <InterpretationPage03 setNextDisabled={setNextDisabled} />;
        }
        case 4: {
          return <InterpretationPage04 />;
        }
        case 5: {
          return <InterpretationPage05 setNextDisabled={setNextDisabled} />;
        }
        case 6: {
          return <InterpretationPage06 setNextDisabled={setNextDisabled} />;
        }
        case 7: {
          return <InterpretationPage07 />;
        }
        case 8: {
          return <InterpretationPage08 />;
        }
        case 9: {
          return <InterpretationPage09 setNextDisabled={setNextDisabled} />;
        }
        case 10: {
          return <InterpretationPage10 setNextDisabledCS={setNextDisabledCS} setNextDisabled={setNextDisabled} />;
        }
        case 11: {
          return <InterpretationPage11 setNextDisabledCS={setNextDisabledCS} />;
        }
        case 12: {
          return <InterpretationPage12 />;
        }
        case 13: {
          return <InterpretationPage13 setNextDisabled={setNextDisabled} setNextDisabledCS={setNextDisabledCS} />;
        }
        case 14: {
          return <InterpretationPage14 setNextDisabled={setNextDisabled} />;
        }
        case 15: {
          return <InterpretationPage15 setNextDisabled={setNextDisabled} />;
        }
        case 16: {
          return <InterpretationPage16 setNextDisabled={setNextDisabled} setNextDisabledCS={setNextDisabledCS} />;
        }
        case 17: {
          return <InterpretationPage17 setNextDisabled={setNextDisabled} />;
        }
        case 18: {
          return <InterpretationPage18 setNextDisabled={setNextDisabled} />;
        }
        case 19: {
          return <InterpretationPage19 />;
        }
        default: {
          return null;
        }
      }
    }
    if (module === 'axuminAcquisition') {
      switch (page) {
        case 1: {
          return <AcquisitionPage01 />;
        }
        case 2: {
          return <AcquisitionPage02 />;
        }
        case 3: {
          return <AcquisitionPage03 setNextDisabled={setNextDisabled} />;
        }
        case 4: {
          return <AcquisitionPage04 />;
        }
        case 5: {
          return <AcquisitionPage05 />;
        }
        case 6: {
          return <AcquisitionPage06 />;
        }
        case 7: {
          return <AcquisitionPage07 setNextDisabled={setNextDisabled} />;
        }
        case 8: {
          return <AcquisitionPage08 setNextDisabled={setNextDisabled} />;
        }
        case 9: {
          return <AcquisitionPage09 setNextDisabled={setNextDisabled} />;
        }
        case 10: {
          return <AcquisitionPage10 />;
        }
        case 11: {
          return <AcquisitionPage11 setNextDisabledCS={setNextDisabledCS} />;
        }
        default: {
          return null;
        }
      }
    }
    return null;
  };

  return (
    <>
      {/* We call the proper component based on the page we are on */}
      {page && renderMainPage()}
    </>
  );
};

export default MainPageAxumin;
